export interface IOnDemandReportResponse {
  lastUpdated?: string;
  id: number;
  name: string;
  rows: any[];
  description?: string;
  fields: any[];
}
